import React from 'react';
import Contact from '../components/Contact';

function ContactPage() {
  return (
    <div className="page-transition pt-20">
      {/* Page Header */}
      <section className="py-20 bg-gradient-to-br from-teal-500 to-cyan-600 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-black mb-6">Contact Us</h1>
          <p className="text-xl text-teal-100 max-w-2xl mx-auto">
            Ready to start your project? Get in touch with us today!
          </p>
        </div>
      </section>
      
      <Contact />
      
      {/* Map Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6">
              Find <span className="text-gradient">Us</span>
            </h2>
          </div>
          <div className="rounded-3xl overflow-hidden shadow-lg">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387193.30596073366!2d-74.25986548248684!3d40.69714941932609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%" 
              height="450" 
              style={{ border: 0 }}
              allowFullScreen="" 
              loading="lazy"
              title="Office Location"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;